import { render } from "./ValueaddDetails.vue?vue&type=template&id=308d870c&scoped=true"
import script from "./ValueaddDetails.vue?vue&type=script&lang=js"
export * from "./ValueaddDetails.vue?vue&type=script&lang=js"

import "./ValueaddDetails.vue?vue&type=style&index=0&id=308d870c&scoped=true&lang=css"

import exportComponent from "C:\\git\\fund\\vfund\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308d870c"]])

export default __exports__